import { useNavigate } from 'react-router-dom';
import Url from '../../data/url';
import { useMyInfoQuery } from '../../queries';
import IcProfile from '../../assets/image/ic_profile.svg';
import { useTranslation } from '../../hook/useTranslation';

function ProfileHeader() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data: userProfile } = useMyInfoQuery();

  return (
    <div className="w-full flex flex-col items-center justify-center p-[20px] py-[24px] rounded-[24px]">
      <div className="border rounded-[40px] overflow-hidden border-[#EAEAEA] bg-white flex items-center justify-center mb-[16px]">
        <img
          src={userProfile?.imageUrl ? userProfile?.imageUrl : IcProfile}
          alt="thumnail1"
          className="w-[100px] h-[100px]"
        />
      </div>
      <div className="font-[600] text-[16px] text-[#1A1A1A]">{userProfile?.nickName || ''}</div>
      <div className="text-[12px] text-[#7D7D7D] mt-[10px] flex items-center justify-center gap-2">
        <button
          type="button"
          onClick={() => navigate(Url.MyParentProfile)}
          className="text-[#5EBEBB] border border-[#E0E0E0] rounded-[5px] font-[600] min-w-[76px] px-2 h-[30px] text-[12px]"
        >
          {t('my.profile.edit_title')}
        </button>
        <button
          type="button"
          onClick={() => navigate(Url.MyKidsManage)}
          className="text-[#5EBEBB] border border-[#E0E0E0] rounded-[5px] font-[600] min-w-[76px] px-2 h-[30px] text-[12px]"
        >
          {t('my.profile.manage_kids')}
        </button>
      </div>
    </div>
  );
}

export default ProfileHeader;
